import React from 'react';
import { useTranslation } from 'react-i18next';

import { VirtualAssistantIcon } from '../../../../../icons/VirtualAssistantIcon';
import HomeBarButton from '../../HomeBarButton/HomeBarButton';
import { useMytaverse } from '../../../../../providers/MytaverseProvider';
import MiraIcon from '../../../../../public/images/MiraIcon.png';
import { env } from '../../../../../env';
import { useStyles } from './styles';
import { useMytaverseEvent } from '../../../providers';

enum VirtualAssistantActions {
  TOGGLE = 'TOGGLE_VIRTUAL_ASSISTANT',
}

const VirtualAssistant = () => {
  const classes = useStyles();
  const { isAssistantDisable } = useMytaverseEvent();

  const { t: translate } = useTranslation('common');
  const { sendMessageToUnreal } = useMytaverse();
  const handleToggleAssistant = () => {
    sendMessageToUnreal({
      action: VirtualAssistantActions.TOGGLE,
    });
  };

  if (!env.REACT_APP_EK_ENV) {
    return (
      <HomeBarButton
        handleClick={handleToggleAssistant}
        icon={<VirtualAssistantIcon />}
        label={translate('tooltips.virtualAssistant')}
      />
    );
  }

  return (
    <HomeBarButton
      handleClick={handleToggleAssistant}
      icon={<img src={MiraIcon} />}
      disabled={isAssistantDisable}
      label={translate('tooltips.virtualAssistant')}
      buttonSx={classes.button}
      sx={{
        '&.Mui-disabled': {
          '& img': {
            filter: 'grayscale(100%)',
            opacity: 0.5,
          },
        },
      }}
    />
  );
};

export default VirtualAssistant;
